import { Button } from '@/components/ui/button';
import { Capacitor } from '@capacitor/core';
import { useMediaQuery } from '@uidotdev/usehooks';
import { AnimatePresence, motion } from 'framer-motion';
import { Smartphone, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const APP_STORE_URL = 'https://apps.apple.com/app/id6755144572';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=dev.zerodays.voicefill.medical';

function getStoreUrl(): string {
  if (typeof navigator === 'undefined') return PLAY_STORE_URL;
  const ua = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua) ? APP_STORE_URL : PLAY_STORE_URL;
}

export function MobileDownloadBanner() {
  const { t } = useTranslation('login');
  const isMobileViewport = useMediaQuery('(max-width: 768px)');
  const [isDismissed, setIsDismissed] = useState(false);

  const isMobileWeb = Capacitor.getPlatform() === 'web' && isMobileViewport;

  const showBanner = isMobileWeb && !isDismissed;

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="sticky top-0 z-40 overflow-hidden">
          <div className="border-primary-border flex items-center gap-3 border-b bg-white px-4 py-3">
            <div className="bg-primary/10 text-primary flex size-10 shrink-0 items-center justify-center rounded-full">
              <Smartphone className="size-5" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-foreground text-sm font-medium">
                {t('downloadBanner.title')}
              </p>
              <p className="text-muted-foreground text-xs">
                {t('downloadBanner.subtitle')}
              </p>
            </div>
            <div className="flex shrink-0 items-center gap-2">
              <Button
                variant="default"
                size="sm"
                className="shrink-0"
                onClick={() => window.open(getStoreUrl(), '_blank')}>
                {t('downloadBanner.cta')}
              </Button>
              <button
                type="button"
                onClick={() => setIsDismissed(true)}
                className="text-muted-foreground hover:text-foreground focus-visible:ring-ring flex size-8 shrink-0 items-center justify-center rounded-md focus-visible:ring-2 focus-visible:outline-none"
                aria-label={t('downloadBanner.dismissA11y')}>
                <X className="size-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
